<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span
        ><a-icon type="wallet" class="margin-right-small" />Payment Schedule
        List</span
      >
      <a-button @click="handleReload" size="small" icon="reload"></a-button>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-card>
          <div style="display: none">
            <a-select
              placeholder="Ex: Need Process ... "
              v-model="tabs.active"
              :disabled="true"
              @change="moreSearch"
              class="width-full"
              initialValue="process"
              allowClear
            >
              <a-select-option value="release">release</a-select-option>
              <a-select-option value="queue">queue</a-select-option>
              <a-select-option value="needprocess">needprocess</a-select-option>
            </a-select>
          </div>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-input-search v-model="search" placeholder="Quick Search" />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-date-picker
                placeholder="Transaction Date"
                v-model="transactionDt"
                :format="getDefaultDateFormat"
                allowClear
              />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-select
                v-model="typetransaction"
                class="width-full"
                initialValue="all"
              >
                <a-select-option value="all">All Type</a-select-option>
                <a-select-option value="KMK">KMK</a-select-option>
                <a-select-option value="Non KMK">Non KMK</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-card>
      </a-card>
      <div class="bordered">
        <a-tabs
          class="custom-tabs"
          :activeKey="tabs.active"
          @change="handleTab"
        >
          <a-tab-pane v-if="!isAkuntansi" key="needprocess">
            <template slot="tab">
              <span>Need Process</span>&nbsp;
              <a-badge
                class="m-badge m-badge-small"
                :count="needProcess.length"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="needProcess.length > 0"
              >
              </a-badge>
            </template>
            <a-table
              :rowKey="(item) => item.id_financing + item.id_financing_dtl"
              key="id_financing_dtl"
              size="small"
              bordered
              :scroll="{ x: 1100 }"
              :columns="columns.needProcess"
              :dataSource="needProcess"
              :loading="tabs.loading"
            >
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{
                  formatCurrency(data.mata_uang, data.value_financing)
                }}</span>
              </template>
              <template slot="remaining" slot-scope="text, data">
                <span>{{
                  formatCurrency(data.mata_uang, data.remaining)
                }}</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button
                    v-if="data.type_financing == 'KMK'"
                    @click="handleLinkKMK(data.id_penarikan)"
                    icon="file"
                  ></a-button>
                  <a-button
                    v-else
                    @click="handleLinkNONKMK(data.id_financing)"
                    icon="file"
                  ></a-button>
                  <!-- <a-button
                    type="primary"
                    @click="handleEditModal(data)"
                    :disabled="
                      data.button_aksi === 'Revised On Process' ? true : false
                    "
                    >Payment</a-button
                  > -->
                  <a-button
                    type="primary"
                    @click="showModal(data)"
                    :disabled="
                      data.button_aksi === 'Revised On Process' ? true : false
                    "
                    >Payment</a-button
                  >
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>

          <a-tab-pane key="release">
            <template slot="tab">
              <span>Payment Release</span>&nbsp;
              <a-badge
                class="m-badge m-badge-small"
                :count="release.length"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="release.length > 0"
              >
              </a-badge>
            </template>
            <a-table
              rowKey="id_payment_schedule"
              size="small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.release"
              :dataSource="release"
              :loading="tabs.loading"
            >
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <a
                slot="seq_bulan_tahun"
                slot-scope="item"
                @click="handleLinkFinancing(item.id_financing)"
                ><b>{{ item.seq_bulan_tahun }}</b>
              </a>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
                /
                <span>{{ data.tlc ? data.tlc : "-" }}</span>
              </template>
              <template slot="description" slot-scope="text, data">
                <span>{{ data.description ? data.description : "-" }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
              </template>
              <template slot="no_bkk" slot-scope="text">
                <span>{{ text ? text : "-" }}</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button
                    @click="handleLinkPaymentSchedule(data.id_payment_schedule)"
                    icon="file"
                    >Manifest</a-button
                  >
                  <a-button
                    :disabled="data.flag_bukti_transfer === '0'"
                    @click="handleDocument(data)"
                    icon="eye"
                    type="primary"
                  ></a-button>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <a-modal
      title="Payment Process"
      :visible="visible"
      @cancel="handleCancel"
    >
      <div>
        <a-form :form="form">
          <a-form-item label="Description">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-decorator="[
                'description',
                { rules: [{ required: true }] },
              ]"
            />
          </a-form-item>
        </a-form>
      </div>
      <template slot="footer">
        <div style="display: flex; justify-content: space-between;">
          <a-button key="back" @click="handleCancel">
            Cancel
          </a-button>
          <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleEditModal(editDataState)">
            Submit
          </a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      v-model="modalBuktiTransfer"
      title="Bukti Transfer"
      :width="500"
      centered
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button @click="handleClose()">Tutup</a-button>
      </template>
      <a-list :dataSource="buktiTransfer">
        <a-list-item class="list-item" slot="renderItem" slot-scope="item">
          <div>
            <h4 class="margin-remove">
              {{
                `${moment(item.tgl_tf).format(getDefaultDateFormat)} | ${
                  item.tlc
                }`
              }}
            </h4>
            <span>{{ formatCurrency(item.currency, item.value_tf) }}</span>
          </div>
          <a-button @click="handleDownload(item)" icon="eye">View </a-button>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import lottie from "vue-lottie";

export default {
  name: "payment-schedule-index",
  components: {
    "m-anim": lottie,
  },
  mixins: [CurrencyFormat, HandleRoute, shortingArray],
  data() {
    const columns = {
      release: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No Payment",
          key: "no_payment_schedule",
          dataIndex: "no_payment_schedule",
          width: 230,
        },
        {
          title: "Angsuran ke",
          key: "angsuran_ke",
          dataIndex: "angsuran_ke",
          align: "center",
          width: 120,
        },
        {
          title: "Jatuh Tempo",
          key: "jatuh_tempo",
          dataIndex: "jatuh_tempo",
          width: 120,
        },
        {
          title: "Type Financing",
          key: "type_financing",
          width: 200,
          dataIndex: "type_financing",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Description",
          key: "description",
          scopedSlots: { customRender: "description" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "No BKK",
          key: "no_bkk",
          dataIndex: "no_bkk",
          scopedSlots: { customRender: "no_bkk" },
          width: 150,
        },
        {
          title: "Action",
          key: "number",
          dataIndex: "number",
          width: 160,
          scopedSlots: { customRender: "aksi" },
          fixed: "right",
          align: "center",
        },
      ],
      queue: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no_transaksi",
          width: 230,
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          dataIndex: "catatan",
          width: 250,
        },
        {
          title: "Supplier",
          key: "supplier",
          width: 200,
          dataIndex: "nama_supplier",
        },
        {
          title: "No Invoice",
          key: "no_invoice",
          width: 150,
          dataIndex: "no_invoice",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Due Date",
          key: "due_date",
          scopedSlots: { customRender: "duedate" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Release",
          key: "release",
          width: 150,
          scopedSlots: { customRender: "aksi" },
          fixed: "right",
          align: "center",
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          align: "center",
          width: 50,
        },
        {
          title: "No",
          key: "no_trans_financing",
          dataIndex: "no_trans_financing",
        },
        {
          title: "Angsuran ke",
          key: "angsuran_ke",
          dataIndex: "angsuran_ke",
          align: "center",
          width: 120,
        },
        {
          title: "Jatuh Tempo",
          key: "jatuh_tempo",
          dataIndex: "jatuh_tempo",
          width: 120,
        },
        {
          title: "Type Financing",
          key: "type_financing",
          dataIndex: "type_financing",
          width: 120,
        },
        {
          title: "Date",
          key: "date",
          dataIndex: "date",
          width: 100,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          align: "right",
        },
        {
          title: "Action",
          scopedSlots: { customRender: "aksi" },
          fixed: "right",
          align: "center",
          width: 150,
        },
      ],
    };
    return {
      columns,
      tabs: {
        active: "needprocess",
        loading: false,
      },
      release: [],
      needProcess: [],
      queue: [],
      release_origin: [],
      needProcess_origin: [],
      queue_origin: [],
      search: undefined,
      typetransaction: "all",
      transactionDt: null,
      buktiTransfer: [],
      modalBuktiTransfer: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      releaseSuplier: [],
      listSuplier: [],
      supplier_nm: undefined,
      revisedStatus: "all",
      editData: {},
      editModal: false,
      indexData: 0,
      loadingCreatePayment: false,
      postData: new FormData(),
      visible: false,
      confirmLoading: false,
      editDataState: {}
    };
  },
  beforeDestroy() {
    Event.$off("handleClose", this.closetrans);
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
    this.form = this.$form.createForm(this);

  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    isAkuntansi() {
      return false;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "needprocess") {
        tempData = this.needProcess_origin;
      } else {
        tempData = this.release_origin;
      }

      if (tempData.length > 0) {
        if (this.tabs.active == "release") {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                (obj.no_payment_schedule &&
                  obj.no_payment_schedule
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no_financing_or_no_detail &&
                  obj.no_financing_or_no_detail
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.type_financing &&
                  obj.type_financing
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no_bkk &&
                  obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                    0) ||
                (obj.create_by &&
                  this.moment(obj.create_by)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.value &&
                  this.formatCurrency("IDR", obj.value)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) || 
                    (obj.jatuh_tempo &&
                  obj.jatuh_tempo
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0)
            );
          }

          if (this.typetransaction && this.typetransaction !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.type_financing && obj.type_financing == this.typetransaction
            );
          }

          if (this.transactionDt) {
            let startDt = moment(this.transactionDt).format("YYYY-MM-DD");
            tempData = tempData.filter(
              (obj) =>
                obj.create_dt &&
                moment(obj.create_dt).format("YYYY-MM-DD") == startDt
            );
          }

          this.intoList(this.tabs.active, tempData);
        } else if (this.tabs.active == "queue") {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                (obj.no_invoice &&
                  obj.no_invoice
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no_transaksi &&
                  obj.no_transaksi
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.catatan &&
                  obj.catatan
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.nama_supplier &&
                  obj.nama_supplier
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.due_date &&
                  this.moment(obj.due_date)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.value &&
                  this.formatCurrency(obj.mata_uang, obj.value)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.tlc_create &&
                  obj.tlc_create
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0)
            );
          }
          this.intoList(this.tabs.active, tempData);
        } else if (this.tabs.active == "needprocess") {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                (obj.no_trans_financing &&
                  obj.no_trans_financing
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no_financing_or_no_detail &&
                  obj.no_financing_or_no_detail
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.type_financing &&
                  obj.type_financing
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.date &&
                  this.moment(obj.date)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.value &&
                  this.formatCurrency("IDR", obj.value)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.remaining &&
                  this.formatCurrency("IDR", obj.remaining)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.jatuh_tempo &&
                  obj.jatuh_tempo
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0)
            );
          }

          if (this.typetransaction && this.typetransaction !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.type_financing && obj.type_financing == this.typetransaction
            );
          }

          if (this.transactionDt) {
            let startDt = moment(this.transactionDt).format(
              this.getDefaultDateFormat
            );
            console.log(startDt);
            tempData = tempData.filter((obj) => obj.date == startDt);
          }
          this.intoList(this.tabs.active, tempData);
        }
      }

      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.typetransaction
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
  },
  mounted() {
    Event.$on("handleClose", this.closetrans);
    if (this.isAkuntansi) {
      this.tabs.active = "release";
    }
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      let urlfetch = "getListPaymentSchedule";
      this.$store.dispatch(urlfetch, { auth: this.getAuth }).then((res) => {
        if (this.isAkuntansi) {
          this.release = res.data.data;
          this.needProcess = {};
          this.queue = {};

          this.release_origin = res.data.data;
          this.needProcess_origin = {};
          this.queue_origin = {};

          this.release.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.needProcessSuplier.sort();

          this.listSuplier = this.needProcessSuplier;
        } else {
          this.release = res.data.data_rilis;
          this.needProcess = res.data.data_onprocess;
          // this.queue = res.data.data_antrian;

          this.release_origin = res.data.data_rilis;
          this.needProcess_origin = res.data.data_onprocess;
          // this.queue_origin = res.data.data_antrian;

          this.needProcess_origin.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.needProcessSuplier.sort();

          this.queue_origin.forEach((element) => {
            if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
              this.quequeSuplier.push(element.nama_supplier);
            }
          });

          this.quequeSuplier.sort();

          this.release_origin.forEach((element) => {
            if (this.releaseSuplier.indexOf(element.nama_supplier) === -1) {
              this.releaseSuplier.push(element.nama_supplier);
            }
          });

          this.releaseSuplier.sort();

          this.listSuplier = this.needProcessSuplier;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = "all";
      this.supplier_nm = "";
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.tabs.loading = true;
      let urlfetch = "getListPaymentSchedule";
      this.$store.dispatch(urlfetch, { auth: this.getAuth }).then((res) => {
        if (this.isAkuntansi) {
          this.release = res.data.data;
          this.needProcess = {};
          this.queue = {};

          this.release_origin = res.data.data;
          this.needProcess_origin = {};
          this.queue_origin = {};

          this.release.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.needProcessSuplier.sort();

          this.listSuplier = this.needProcessSuplier;
          this.tabs.loading = false;
        } else {
          this.release = res.data.data_rilis;
          this.needProcess = res.data.data_onprocess;
          // this.queue = res.data.data_antrian;

          this.release_origin = res.data.data_rilis;
          this.needProcess_origin = res.data.data_onprocess;
          // this.queue_origin = res.data.data_antrian;

          this.tabs.loading = false;

          this.needProcess_origin.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.queue_origin.forEach((element) => {
            if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
              this.quequeSuplier.push(element.nama_supplier);
            }
          });

          this.release_origin.forEach((element) => {
            if (this.releaseSuplier.indexOf(element.supplier) === -1) {
              this.releaseSuplier.push(element.nama_supplier);
            }
          });

          this.listSuplier = this.needProcessSuplier;
        }
      });
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      if (val === "needprocess") {
        this.listSuplier = this.needProcessSuplier;
        this.revisedStatus = "all";
      } else if (val === "queue") {
        this.listSuplier = this.quequeSuplier;
      } else if (val === "release") {
        this.listSuplier = this.releaseSuplier;
      }
    },
    handleCreate(item) {
      console.log("ini di create");
      console.log(item);

      // this.$router.push({
      //   name: "account-pay-create",
      //   params: { id: item.id, type: item.jenis_id },
      // });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api: item.jenis_transaksi
          ? item.jenis_transaksi.toLowerCase()
          : item.jenis.toLowerCase(),
        id_manifest: item.id,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleManifest(item) {
      if (this.isAkuntansi) {
        this.$router.push({
          name: "Spclaccount-pay-manifest",
          params: { id: item.id_account_pay },
        });
      } else {
        this.$router.push({
          name: "account-pay-manifest",
          params: { id: item.id_account_pay },
        });
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiPS", {
          auth: this.getAuth,
          id: item.id_payment_schedule,
        })
        .then((res) => {
          this.buktiTransfer = res.data.bukti_tf;
          this.modalBuktiTransfer = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleClose() {
      this.modalBuktiTransfer = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() {},
      });
    },
    handleLinkPaymentSchedule(id) {
      this.$router.push({
        name: "PaymentScheduleManifestKeu",
        params: { id: id },
      });
    },
    handleLinkFinancing(id) {
      this.$router.push({ name: "financing-manifest", params: { id: id } });
    },
    handleEditModal(item) {
      this.form.validateFields((err, values) => {
        this.confirmLoading = true
        // this.editData = item;
        // this.indexData++;
        // this.editModal = !this.editModal;
        if(err){
          this.confirmLoading = false
          return;
        }
        
        let data = {
          id_financing: item.id_financing,
          id_financing_dtl: item.id_financing_dtl,
          pokok: item.pokok,
          tlc: this.getAuth.username,
          bunga: item.bunga,
          type_financing: item.type_financing,
          description: values.description
        };
        
        this.tabs.loading = true;
        axios({
          method: "POST",
          url: this.$serviceUrl + "payment_schedule",
          processData: false,
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: { "X-API-KEY": this.getAuth.apikey },
        }).then((response) => {
          console.log(response);
          this.tabs.loading = false;
          this.displayMessageValue("successClose", response.data.message);
          this.fetch();
          this.visible = false
          this.confirmLoading = false
          this.form.resetFields();
        }).catch((error) => {
          this.tabs.loading = false;
          this.confirmLoading = false
          let response = Object.assign({}, error.response.data);
          if (response.status === false) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
        });
      })
    },
    handleCancel() {
      this.editModal = false;
    },
    handleModalEdit() {
      //this.confirmMessageValue("confirm-save", null, null);
      const that = this;
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        let data = {
          tlc: that.getAuth.username,
          id_financing: that.editData.id_financing,
          id_financing_dtl: that.editData.id_financing_dtl,
          pokok: values.biaya_pokok,
          description: values.description,
        };
        if (this.editData.type_financing === "KMK") {
          data.bunga = values.bunga;
          if (values.biaya_pokok <= 0) {
            if (values.bunga <= 0) {
              this.displayMessage("value-0");
              return;
            }
          }
        } else {
          if (values.biaya_pokok <= 0) {
            this.displayMessage("value-0");
            return;
          }
        }

        that.loadingCreatePayment = true;
        axios({
          method: "POST",
          url: that.$serviceUrl + "payment_schedule",
          processData: false,
          data: data,
          auth: {
            username: that.getAuth.username,
            password: that.getAuth.password,
          },
          headers: { "X-API-KEY": that.getAuth.apikey },
        })
          .then((response) => {
            that.loadingCreatePayment = false;
            that.displayMessageValue("successClose", response.data.message);
            that.$router.go();
          })
          .catch((error) => {
            that.printLoad.cancel = false;
            let response = Object.assign({}, error.response.data);
            if (response.status === false) {
              that.displayMessageValue("error-other", response.message);
            } else {
              //this.displayMessageValue("error-other", error);
              that.displayMessageValue("error", error.message);
            }
          });
      });
    },
    handleSave() {},
    handleClosePS(params) {
      console.log(params);
      this.confirmMessageValue("confirm-close", params, null);
    },
    closetrans(item) {
      // const data = {
      //   id_financing: item.id_financing,
      //   tlc: this.getAuth.username,
      // };
      this.postData.append("id_financing", item.id_financing);
      this.postData.append("tlc", this.getAuth.username);
      const data = this.postData;
      this.$store
        .dispatch("closePS", {
          auth: this.getAuth,
          data,
        })
        .then((res) => {
          this.displayMessageValue("successClose", res.message);
          //this.$router.go();
        })
        .then((error) => {
          let response = Object.assign({}, error.response.data);
          if (response.status) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
        });
    },
    handleLinkNONKMK(id) {
      this.$router.push({
        name: "financing-manifest",
        params: { id: id },
      });
    },
    handleLinkKMK(id) {
      this.$router.push({
        name: "penarikan-financing-manifest",
        params: { id: id },
      });
    },

    showModal(params) {
      this.visible = true;
      this.editDataState = params
    },
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      console.log('Clicked cancel button');
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}
</style>
//
